import { apiClient } from './authService';

const supplierRequestService = {
  // Récupérer toutes les demandes fournisseurs
  getAll: async (params = {}) => {
    const response = await apiClient.get('/supplier-requests/', { params });
    return response.data;
  },

  // Récupérer une demande par ID
  getById: async (id) => {
    const response = await apiClient.get(`/supplier-requests/${id}/`);
    return response.data;
  },

  // Créer une nouvelle demande
  create: async (data) => {
    const response = await apiClient.post('/supplier-requests/', data);
    return response.data;
  },

  // Mettre à jour une demande
  update: async (id, data) => {
    const response = await apiClient.patch(`/supplier-requests/${id}/`, data);
    return response.data;
  },

  // Supprimer une demande
  delete: async (id) => {
    const response = await apiClient.delete(`/supplier-requests/${id}/`);
    return response.data;
  },

  // Approuver une demande
  approve: async (id) => {
    const response = await apiClient.post(`/supplier-requests/${id}/approve/`);
    return response.data;
  },

  // Rejeter une demande
  reject: async (id, reason) => {
    const response = await apiClient.post(`/supplier-requests/${id}/reject/`, { reason });
    return response.data;
  },

  // Marquer comme terminée
  complete: async (id) => {
    const response = await apiClient.post(`/supplier-requests/${id}/complete/`);
    return response.data;
  },

  // Récupérer les fournisseurs
  getSuppliers: async () => {
    const response = await apiClient.get('/suppliers/');
    return response.data;
  },

  // Récupérer les demandes par fournisseur
  getBySupplier: async (supplierId, params = {}) => {
    const response = await apiClient.get(`/supplier-requests/by-supplier/${supplierId}/`, { params });
    return response.data;
  },

  // Récupérer les statistiques
  getStats: async (params = {}) => {
    const response = await apiClient.get('/supplier-requests/stats/', { params });
    return response.data;
  }
};

export default supplierRequestService;
